import React from "react";
import { DataGridHeader } from "./DataGridHeader";
import { DataGridPagination } from "./DataGridPagination";
import { DataGridRecords } from "./DataGridRecords";
import { DataGridSearch } from "./DataGridSearch";
import { Alert } from "@mui/material";

export const DataGrid = ({
  columns,
  handleRowClick,
  search,
  handleChangeSearch,
  clearSearch,
  limit,
  currentPage,
  totalPages,
  handleChangeRecordsPerPage,
  handleChangePage,
  sorter,
  handleSort,
  rows,
  totalCount,
  visibility,
  defaultLimit,
  error,
  title,
  loadData,
  withRefreshButton = false,
}) => {
  return (
    <>
      <DataGridSearch
        search={search}
        handleChangeSearch={handleChangeSearch}
        clearSearch={clearSearch}
        title={title}
        loadData={loadData}
        withRefreshButton={withRefreshButton}
      />
      {error && <Alert severity="error">{error}</Alert>}
      <DataGridHeader
        columns={columns}
        sorter={sorter}
        handleSort={handleSort}
        visibility={visibility}
      />
      <DataGridRecords
        columns={columns}
        rows={rows}
        handleRowClick={handleRowClick}
        visibility={visibility}
      />
      <DataGridPagination
        currentPage={currentPage}
        handleChangePage={handleChangePage}
        defaultLimit={defaultLimit}
        limit={limit}
        handleChangeRecordsPerPage={handleChangeRecordsPerPage}
        totalPages={totalPages}
        count={totalCount}
      />
    </>
  );
};
